import React, {FC} from 'react'
import CommerciumLoader, {CommerciumLoaderVariant} from './CommerciumLoader'

export type LoaderVariant = CommerciumLoaderVariant

interface LoaderProps {
  variant?: LoaderVariant
}

/** Legacy app loader: cart mark, no copy, plain layout (replaces Bootstrap spinner). */
const Loader: FC<LoaderProps> = ({variant = 'page'}) => {
  return <CommerciumLoader variant={variant} layout='plain' message='' />
}

export default Loader
